
























































































































































































































// decoradores
import { Vue, Component } from "vue-property-decorator";
// vuex
import { mapActions, mapGetters } from "vuex";
// tipos

// componentes
import TablaRegistrosEgresos from "@/components/registrosEgresos/Tabla.vue";
import FormularioRegistrosEgresos from "@/components/registrosEgresos/Formulario.vue";
import InfoRegistrosEgresos from "@/components/registrosEgresos/Info.vue";
import ExportarExcelGenerico from "@/components/ExportarExcelGenerico.vue";
import ExportarPdfGenerico from "@/components/ExportarPdfGenerico.vue";
import MensajeEliminar from "@/components/MensajeEliminar.vue";
import {
  Egresos,
  RegistrosEgresos,
} from "@/typings/store/plugins/easyFirestore/registrosEgresos";
import { Banco } from "@/typings/store/plugins/easyFirestore/bancos";
import { CentroCosto } from "@/typings/store/plugins/easyFirestore/centrosCostos";
import { CodCuenta } from "@/typings/store/plugins/easyFirestore/codCuentas";
import { TipoEgreso } from "@/typings/store/plugins/easyFirestore/tipoEgresos";
import { Proveedor } from "@/typings/store/plugins/easyFirestore/proveedores";
import { TipoDocumento } from "@/typings/store/plugins/easyFirestore/tipoDocumentos";
import { TipoCargo } from "@/typings/store/plugins/easyFirestore/tipoCargos";
import {
  // MapeoGastos,
  MapeoGasto,
} from "@/typings/store/plugins/easyFirestore/MapeoGastos";
import CargarRegistrosEgresosExcel from "@/components/excel/CargarRegistrosEgresos.vue";
import { DataFormularioRegistrosEgresos } from "@/typings/components/registrosEgresos/formulario";

const routeGuard = (vm: Vue): boolean => {
  const permisos = vm.getUsuario?.permisos;
  if (permisos && permisos["registrosEgresos"]) {
    return true;
  }

  const rutas = vm.getRutasUsuario;
  if (rutas.length > 0) {
    const to = rutas[0].to;
    if (to) {
      if (vm.$route.name !== to.name) {
        vm.$router.replace(to);
      }
      return false;
    }
  }
  if (vm.$route.name !== "inicio") {
    vm.$router.replace({ name: "inicio" });
  }
  return false;
};

@Component({
  computed: mapGetters({
    getRegistrosEgresos: "registrosEgresos/get",
    // getEgresos: "egresos/get",
    getArrayRegistrosEgresos: "registrosEgresos/getArray",
    getUsuario: "usuario/get",
    getRutasUsuario: "usuario/getRutas",
    getArrayBancos: "bancos/getArray",
    getArrayCentrosCostos: "centrosCostos/getArray",
    getArrayCodCuentas: "codCuentas/getArray",
    getArrayTipoEgresos: "tipoEgresos/getArray",
    getArrayProveedores: "proveedores/getArray",
    getArrayTipoDocumentos: "tipoDocumentos/getArray",
    getArrayTipoCargos: "tipoCargos/getArray",
    getArrayMapeoGastos: "mapeoGastos/getArray",
    getArrayPrenominas: "prenominas/getArray",
  }),
  methods: mapActions({
    setEgreso: "registrosEgresos/set",
    deleteEgreso: "registrosEgresos/delete",
    insertBatchEgreso: "registrosEgresos/insertBatch",
  }),
  beforeRouteEnter(to, from, next) {
    next(routeGuard);
  },
  components: {
    TablaRegistrosEgresos,
    FormularioRegistrosEgresos,
    InfoRegistrosEgresos,
    ExportarExcelGenerico,
    ExportarPdfGenerico,
    MensajeEliminar,
    CargarRegistrosEgresosExcel,
  },
})
export default class VistaRegistrosEgresos extends Vue {
  created(): void {
    if (!routeGuard(this)) {
      return;
    }
  }
  cargando = false;
  dialogoExito = {
    model: false,
    texto: "",
    icono: "",
  };
  search = "";
  seleccionadorPeriodo = "";
  seleccionadorFechaEgreso = "";
  seleccionadorNCliente = "";
  seleccionadorNNomina = "";
  seleccionadorBanco = "";
  seleccionadorNDocumento = "";
  banco: Banco | null = null;
  centroCosto: CentroCosto | null = null;
  codCuenta: CodCuenta | null = null;
  tipoEgreso: TipoEgreso | null = null;
  proveedor: Proveedor | null = null;
  tipoDocumento: TipoDocumento | null = null;
  tipoCargo: TipoCargo | null = null;
  mapeoGasto: MapeoGasto | null = null;
  registrosEgresos: RegistrosEgresos | null = null; //region: Region | null = null;
  dialogoInfo = false;
  dialogoFormulario = false;
  dialogoEliminar = false;
  dialogoCargarExcel = false;

  get egresos(): Egresos {
    //regiones
    return this.getRegistrosEgresos;
  }

  /** Lista filtrada: todos los filtros se aplican en AND */
  get items(): Array<RegistrosEgresos> {
    const {
      seleccionadorPeriodo,
      seleccionadorBanco,
      seleccionadorFechaEgreso,
      seleccionadorNCliente,
      seleccionadorNNomina,
      seleccionadorNDocumento,
    } = this;
    const hasFilters =
      !!seleccionadorPeriodo ||
      !!seleccionadorBanco ||
      !!seleccionadorFechaEgreso ||
      !!seleccionadorNCliente ||
      !!seleccionadorNNomina ||
      !!seleccionadorNDocumento;
    if (!hasFilters) return this.getArrayRegistrosEgresos;
    return this.getArrayRegistrosEgresos.filter((e) => {
      if (seleccionadorPeriodo && e.PERIODO !== seleccionadorPeriodo) return false;
      if (seleccionadorBanco && e.BANCO !== seleccionadorBanco) return false;
      if (seleccionadorFechaEgreso && e.FECHA_EGRESO !== seleccionadorFechaEgreso) return false;
      if (seleccionadorNCliente && e.N_CLIENTE !== seleccionadorNCliente) return false;
      if (seleccionadorNNomina && e.N_NOMINA !== seleccionadorNNomina) return false;
      if (seleccionadorNDocumento && e.N_DOCUMENTO !== seleccionadorNDocumento) return false;
      return true;
    });
  }

  get selectPeriodo(): Array<string> {
    let periodo = "";
    let arrayPeriodos = [periodo];
    this.getArrayRegistrosEgresos.forEach((registro) => {
      arrayPeriodos.push(registro.PERIODO);
    });

    const unicos = arrayPeriodos.filter((valor, indice) => {
      return arrayPeriodos.indexOf(valor) === indice;
    });

    unicos.sort((a, b) => {
      const fechaA = new Date(a);
      const fechaB = new Date(b);
      return fechaB.getTime() - fechaA.getTime();
    });
    return unicos;
  }
  //
  get selectNDocumento(): Array<string> {
    let nCliente = "";
    let arrayNCliente = [nCliente];
    this.getArrayRegistrosEgresos.forEach((registro) => {
      arrayNCliente.push(registro.N_DOCUMENTO);
    });

    const unicos = arrayNCliente.filter((valor, indice) => {
      return arrayNCliente.indexOf(valor) === indice;
    });

    unicos.sort();
    return unicos;
  }

  get selectBancos(): Array<string> {
    let banco = "";
    let arrayBancos = [banco];
    this.getArrayRegistrosEgresos.forEach((registro) => {
      arrayBancos.push(registro.BANCO);
    });

    const unicos = arrayBancos.filter((valor, indice) => {
      return arrayBancos.indexOf(valor) === indice;
    });
    return unicos.sort();
  }

  get selectFechaEgreso(): Array<string> {
    //define fecha vacia

    let fecha = "";
    let arrayFechas = [fecha];
    this.getArrayRegistrosEgresos.forEach((registro) => {
      arrayFechas.push(registro.FECHA_EGRESO);
    });

    const unicos = arrayFechas.filter((valor, indice) => {
      return arrayFechas.indexOf(valor) === indice;
    });

    // ordena unicos
    return unicos.sort();
  }

  get selectNCliente(): Array<string> {
    //define fecha vacia

    let nCliente = "";
    let arrayNCliente = [nCliente];
    this.getArrayRegistrosEgresos.forEach((registro) => {
      arrayNCliente.push(registro.N_CLIENTE);
    });

    const unicos = arrayNCliente.filter((valor, indice) => {
      return arrayNCliente.indexOf(valor) === indice;
    });

    // ordena unicos
    return unicos.sort();
  }

  get selectNNomina(): Array<string> {
    const arrayNNomina = this.getArrayRegistrosEgresos
      .map((registro) => registro.N_NOMINA)
      .filter((n) => n); // elimina null, undefined o ""

    const unicos = [...new Set(arrayNNomina)];

    return unicos.sort((a, b) =>
      b.localeCompare(a, undefined, { numeric: true, sensitivity: "base" })
    );
  }

  clickItem(val: { id: string } | null): void {
    this.registrosEgresos = val ? this.egresos[val.id] : null;
  }

  clickPlus(): void {
    this.registrosEgresos = null;
    this.dialogoFormulario = true;
  }

  async clickGuardar(data: DataFormularioRegistrosEgresos): Promise<void> {
    this.cargando = true;
    const doc = data.doc;
    this.setEgreso(doc);
    if (doc.id != this.registrosEgresos?.id) {
      this.dialogoExito = {
        model: true,
        texto: "¡Registro creado con éxito!",
        icono: require("../assets/icons/double-check-duo.svg"),
      };
    }
    if (doc.id == this.registrosEgresos?.id) {
      this.dialogoExito = {
        model: true,
        texto: "¡Registro editado con éxito!",
        icono: require("../assets/icons/editar.svg"),
      };
      this.registrosEgresos = doc;
    }
    this.cerrarDialogoFormulario();
    this.cargando = false;
  }

  clickEliminar(): void {
    const registrosEgresos = this.registrosEgresos;
    if (!registrosEgresos?.id) {
      console.error("error id: ", registrosEgresos);
      return;
    }
    this.deleteEgreso(registrosEgresos.id);
    this.registrosEgresos = null;
    this.cerrarDialogoEliminar();
  }

  abrirDialogoInfo(registrosEgresos: RegistrosEgresos): void {
    if (!registrosEgresos.id) {
      console.error("error id: ", registrosEgresos);
      return;
    }
    const doc = this.egresos[registrosEgresos.id];
    if (doc) {
      this.registrosEgresos = doc;
      this.dialogoInfo = true;
    }
  }

  cerrarDialogoInfo(): void {
    this.dialogoInfo = false;
    this.registrosEgresos = null;
  }

  abrirDialogoFormulario(registrosEgresos: RegistrosEgresos): void {
    if (!registrosEgresos.id) {
      console.error("error id: ", registrosEgresos);
      return;
    }
    const doc = this.egresos[registrosEgresos.id];
    if (doc) {
      this.registrosEgresos = doc;
      this.dialogoFormulario = true;
    }
  }

  cerrarDialogoFormulario(): void {
    this.dialogoFormulario = false;
    this.registrosEgresos = null;
  }

  abrirDialogoEliminar(registrosEgresos: RegistrosEgresos): void {
    if (!registrosEgresos.id) {
      console.error("error id: ", registrosEgresos);
      return;
    }
    const doc = this.egresos[registrosEgresos.id];
    if (doc) {
      this.dialogoEliminar = true;
      this.registrosEgresos = doc;
    }
  }

  cerrarDialogoEliminar(): void {
    this.dialogoEliminar = false;
    this.registrosEgresos = null;
  }

  get columnasExportacionEgresos(): Array<{ label: string; field: string }> {
    return [
      { label: "Período", field: "PERIODO" },
      { label: "Centro de costo", field: "CENTRO_DE_COSTO" },
      { label: "Cuenta", field: "DESCRIPCION_CUENTA" },
      { label: "Código cuenta", field: "CODIGO_CUENTA" },
      { label: "Banco", field: "BANCO" },
      { label: "Orden compra", field: "ORDEN_DE_COMPRA" },
      { label: "Fecha egreso", field: "FECHA_EGRESO" },
      { label: "Tipo egreso", field: "TIPO_EGRESO" },
      { label: "Monto egreso", field: "MONTO_EGRESO" },
      { label: "Glosa", field: "GLOSA" },
      { label: "RUT proveedor", field: "RUT_PROVEEDOR" },
      { label: "Nombre proveedor", field: "NOMBRE_PROVEEDOR" },
      { label: "Nómina pago", field: "NOMINA_PAGO" },
      { label: "N° documento", field: "N_DOCUMENTO" },
      { label: "Factura/doc", field: "FAC_DOC_NOTA" },
      { label: "Tipo gasto", field: "TIPO_GASTO" },
      { label: "N° cliente", field: "N_CLIENTE" },
      { label: "N° nómina", field: "N_NOMINA" },
    ];
  }

  get subtituloExportacion(): string {
    const parts: string[] = [];
    if (this.seleccionadorPeriodo) parts.push(`Período: ${this.seleccionadorPeriodo}`);
    if (this.seleccionadorBanco) parts.push(`Banco: ${this.seleccionadorBanco}`);
    if (this.seleccionadorFechaEgreso) parts.push(`Fecha: ${this.seleccionadorFechaEgreso}`);
    if (this.seleccionadorNCliente) parts.push(`N° Cliente: ${this.seleccionadorNCliente}`);
    if (this.seleccionadorNNomina) parts.push(`N° Nómina: ${this.seleccionadorNNomina}`);
    if (this.seleccionadorNDocumento) parts.push(`N° Doc: ${this.seleccionadorNDocumento}`);
    return parts.length > 0 ? parts.join(" · ") : "";
  }
}
